"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { YellowCardIcon, RedCardIcon } from "@/components/ui/icons/PlayerEventIcons";
import { PlayerImage } from "./PlayerImage";
import { PlayerLink } from "./PlayerLink";
import { getEventTypeLabel, getPlayerPhoto, type EventLabels } from "./matchEventHelpers";
interface CardEventCardProps {
  event: FUSportsMatchEvent;
  showPhotos: boolean;
  eventLabels: EventLabels;
}

/**
 * CardEventCard - Displays a yellow/red card event
 */
export const CardEventCard: React.FC<CardEventCardProps> = t0 => {
  const $ = _c(25);
  const {
    event,
    showPhotos,
    eventLabels
  } = t0;
  let t1;
  if ($[0] !== event.type || $[1] !== eventLabels) {
    t1 = getEventTypeLabel(event.type, eventLabels);
    $[0] = event.type;
    $[1] = eventLabels;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const typeLabel = t1;
  const player = event.primaryPlayer;
  let t2;
  if ($[3] !== player) {
    t2 = getPlayerPhoto(player);
    $[3] = player;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const playerPhoto = t2;
  const isRed = event.type === "RED_CARD" || event.type === "YELLOW_RED_CARD";
  let t3;
  if ($[5] !== isRed) {
    t3 = isRed ? <RedCardIcon /> : <YellowCardIcon />;
    $[5] = isRed;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== typeLabel) {
    t4 = <span className="text-xs font-semibold text-muted-foreground uppercase">{typeLabel}</span>;
    $[7] = typeLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-2 mb-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== player?.name || $[13] !== playerPhoto || $[14] !== showPhotos) {
    t6 = showPhotos && <PlayerImage photoUrl={playerPhoto} name={player?.name || "Unknown"} />;
    $[12] = player?.name;
    $[13] = playerPhoto;
    $[14] = showPhotos;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = player?.id;
  const t8 = player?.name || "Unknown";
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <PlayerLink playerId={t7} className="text-sm font-semibold text-foreground">{t8}</PlayerLink>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="flex items-center gap-2">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <div className="bg-muted border border-border rounded-lg p-3 shadow-sm min-w-0 w-48 md:w-72">{t5}{t10}</div>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};